import * as corgi from 'external/dev_april_corgi+/js/corgi';
import {CHANGED} from 'external/dev_april_corgi+/js/emu/events';
import {Input} from 'external/dev_april_corgi+/js/emu/input';

import {NODE as NODE_BREAKOUT_MATERIALS} from './nodes/breakout_materials_node';
import {NODE_STORE_MATERIALS, NODE_MIX_TABLE} from './nodes/nodes';
import {NODE as NODE_MAGNETIC_BEAD_WASH} from './nodes/magnetic_bead_wash_node';
import {NODE as NODE_MIX_ARRAY} from './nodes/mix_array_node';
import {NODE as NODE_MIX_PRODUCT} from './nodes/mix_product_node';
import {NODE as NODE_MIX_ZIPPER} from './nodes/mix_zipper_node';
import {NODE as NODE_PLATED_MATERIAL} from './nodes/plated_material_node';
import {NODE as NODE_SERIAL_DILUTIONS} from './nodes/serial_dilutions_node';
import {
  NODE_SUBGRAPH_INPUT,
  NODE_SUBGRAPH_OUTPUT,
} from './nodes/subgraph_nodes';
import {NODE as NODE_THERMOCYCLE} from './nodes/thermocycling_node';

import {GraphController, State} from './graph_controller';
import {Menu, MenuItem} from './menu_controller';

export const ADD_NODE_MENU: Array<Menu | MenuItem> = [
  {
    kind: 'menu',
    label: 'Input/output',
    items: [
      {
        kind: 'menu_item',
        label: NODE_PLATED_MATERIAL.label,
        action: ({graph, position}) => {
          graph.addNode(position, NODE_PLATED_MATERIAL);
        },
      },
      {
        kind: 'menu_item',
        label: NODE_STORE_MATERIALS.label,
        action: ({graph, position}) => {
          graph.addNode(position, NODE_STORE_MATERIALS);
        },
      },
      {
        kind: 'menu_item',
        label: NODE_SUBGRAPH_INPUT.label,
        action: ({graph, position}) => {
          graph.addNode(position, NODE_SUBGRAPH_INPUT);
        },
      },
      {
        kind: 'menu_item',
        label: NODE_SUBGRAPH_OUTPUT.label,
        action: ({graph, position}) => {
          graph.addNode(position, NODE_SUBGRAPH_OUTPUT);
        },
      },
    ],
  },
  {
    kind: 'menu_item',
    label: NODE_BREAKOUT_MATERIALS.label,
    action: ({graph, position}) => {
      graph.addNode(position, NODE_BREAKOUT_MATERIALS);
    },
  },
  {
    kind: 'menu_item',
    label: NODE_MAGNETIC_BEAD_WASH.label,
    action: ({graph, position}) => {
      graph.addNode(position, NODE_MAGNETIC_BEAD_WASH);
    },
  },
  {
    kind: 'menu',
    label: 'Mix',
    items: [
      {
        kind: 'menu_item',
        label: 'Product',
        action: ({graph, position}) => {
          graph.addNode(position, NODE_MIX_PRODUCT);
        },
      },
      {
        kind: 'menu_item',
        label: 'Table',
        action: ({graph, position}) => {
          graph.addNode(position, NODE_MIX_TABLE);
        },
      },
      {
        kind: 'menu_item',
        label: 'Uniformly',
        action: ({graph, position}) => {
          graph.addNode(position, NODE_MIX_ARRAY);
        },
      },
      {
        kind: 'menu_item',
        label: 'Zipper',
        action: ({graph, position}) => {
          graph.addNode(position, NODE_MIX_ZIPPER);
        },
      },
    ],
  },
  {
    kind: 'menu_item',
    label: NODE_SERIAL_DILUTIONS.label,
    action: ({graph, position}) => {
      graph.addNode(position, NODE_SERIAL_DILUTIONS);
    },
  },
  {
    kind: 'menu_item',
    label: 'Subgraph',
    action: ({controller, position}) => {
      controller.addSubgraph(position);
    },
  },
  {
    kind: 'menu_item',
    label: NODE_THERMOCYCLE.label,
    action: ({graph, position}) => {
      graph.addNode(position, NODE_THERMOCYCLE);
    },
  },
];

export function GraphElement(
  {
    className,
    key,
    ref,
  }: {
    className: string;
    key?: string;
    ref?: string;
  },
  state: State | undefined,
  updateState: (newState: State) => void,
) {
  if (!state) {
    state = {
      input: undefined,
      padInfo: undefined,
    };
  }

  return (
    <div
      className={'relative text-sm ' + className}
      js={corgi.bind({
        controller: GraphController,
        key,
        ref,
        args: {addMenuItems: ADD_NODE_MENU},
        events: {
          render: 'wakeup',
        },
        state: [state, updateState],
      })}
    >
      {state.input ? (
        <div
          className="absolute"
          style={[
            `left: ${state.input.position.x}px`,
            `top: ${state.input.position.y}px`,
            `transform: translate(-50%, -50%) scale(${state.input.scale})`,
            `width: ${state.input.size.x}px`,
            `height: ${state.input.size.y}px`,
          ].join('; ')}
        >
          <Input
            autofocus
            className="bg-neutral-700 h-full px-1 rounded text-sm w-full focus-within:outline"
            value={state.input.value}
            unboundEvents={{corgi: [[CHANGED, 'inputChanged']]}}
          />
        </div>
      ) : (
        <></>
      )}
      {state.padInfo ? (
        <div
          className="absolute bg-neutral-800 p-2 rounded shadow-md max-w-96"
          style={[
            `left: ${state.padInfo.position.x - 8}px`,
            `top: ${state.padInfo.position.y + 16}px`,
          ].join('; ')}
        >
          {state.padInfo.content}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
